<template>
    <div>
        <!-- 逻辑 -->
        <div class="logic">
            <div class="jump_logic">
                <p>跳转逻辑</p>
                <div v-if="dynamicValidateForm.domains == ''" class="add_box">
                    <i class="icon iconfont iconlianxirenicon-01" @click="addjumpLogic()"></i>
                  <!--暂时隐藏新增逻辑-->
                   <!-- <span @click="addjumpLogic()">新增逻辑</span>-->
                </div>
                <div v-if="dynamicValidateForm.domains != ''" style="margin-top:20px">
                    <div class="public_box">
                        <span>共{{dynamicValidateForm.domains.length}}条跳转逻辑</span>
                      <!--暂时隐藏新增逻辑-->
                        <!--<el-button type="primary" @click="addjumpLogic()">新增逻辑</el-button>-->
                    </div>
                    <div style="width:100%;height:auto;background:#ffffff;border-bottom:#e3e3e3;">
                        <el-form :model="dynamicValidateForm" label-width="31px"  class="demo-form-inline" >
                            <el-form-item
                                v-for="(domain, index) in dynamicValidateForm.domains"
                                :label="index+1+'.'"
                                :key="domain.key"
                                >
                                <div class="choiceQuestion" style="float:left">
                                    <span style="margin-right:10px">如果</span>
                                    <el-select v-model="domain.choicQues" placeholder="请选择题目" value-key="id" @change="choiceTitle">
                                        <el-option
                                            v-for="item in questionList"
                                            :key="item.id"
                                            :label="item.questionsName"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="labelClass" style="float:left">
                                    <span style="margin:0 10px">选择了</span>
                                    <el-select v-model="domain.selectOption" placeholder="请选择选项" value-key="id" @change='optionId'>
                                        <el-option
                                            v-for="item in domain.optionList"
                                            :key="item.id"
                                            :label="item.labelName"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="skipClass" style="floart:left">
                                    <span style="margin:0 10px">则跳转到</span>
                                    <el-select v-model="domain.quesTitle" placeholder="请选择题目" value-key="id" @change="jumpTitle">
                                        <el-option
                                            v-for="item in questionList"
                                            :key="item.id"
                                            :label="item.questionsName"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                  <!--暂时隐藏删除-->
                                    <!--<i class="icon iconfont iconlianxirenicon-09" @click.prevent="removeDomain(domain)" style="margin-left:407px"></i>-->
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                    
                </div>
            </div>

            <div class='display_logic'>
                <p>显示逻辑</p>
              <div v-if="displayscriptitem.length == 0" class="add_box">
                    <i class="icon iconfont iconlianxirenicon-01" @click="adddisplayLogic()"></i>
                <!--暂时隐藏新增逻辑-->
                   <!-- <span @click="adddisplayLogic()">新增逻辑</span>-->
                </div>
                <div  style="margin-top:20px">
                    <div class="public_box">
                        <span>共{{displayscriptitem.length}}条显示逻辑</span>
                      <!--暂时隐藏新增逻辑-->
                        <!--<el-button type="primary" @click="adddisplayLogic1()">新增逻辑</el-button>-->
                    </div>
                    <div style="width:100%;height:auto;background:#ffffff;border-bottom:#e3e3e3;">
                    <el-form :model="displayscriptitem" label-width="31px"  class="demo-form-inline" >
                            <label v-for="(item,i) in displayscriptitem" :key="i" style="border-bottom:1px solid #cccccc">
                                <el-form-item
                                    :label="i+1+'.'"
                                    :key="item.key"
                                    style="border-bottom:none">
                                    <div style="float:left">
                                        <el-select v-model="item.questionid" placeholder="请选择问题" value-key="id" @change="quesName">
                                            <el-option
                                                v-for="item in questionList"
                                                :key="item.id"
                                                :label="item.questionsName"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div style="float:left">
                                        <span style="margin-left:10px">符合以下</span>
                                        <el-select v-model="item.condition" placeholder="全部" value-key="id"  style="margin:0 10px" @change="elig">
                                            <el-option
                                                v-for="item in custom"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <span>条件时显示此问题:</span>
                                    </div>
                                </el-form-item>

                              <el-form-item
                                  v-for="(domain, index) in item.domians"
                                  :key="index"
                              >
                                <!-- 请选择题目 -->
                                <div class="choiceQuestion" style="float: left">
                                  <el-select
                                      v-model="domain.title"
                                      domainindex=""
                                      placeholder="请选择题目"
                                      value-key="id"

                                  >
                                    <el-option
                                        v-for="item in questionList"
                                        :key="item.id"
                                        :label="
                            item.serialNumber
                              ? 'Q' +
                                item.serialNumber +
                                ' ' +
                                item.questionsName
                              : item.questionsName
                          "
                                        :value="item.id"
                                    >
                                    </el-option>
                                  </el-select>
                                </div>
                                <div
                                    class="labelClass"
                                    style="float: left; margin-left: 15px; margin-right: 15px"
                                >
                                  <el-select
                                      v-model="domain.condSelect"
                                      placeholder="请选择条件"
                                      value-key="id"
                                  >
                                    <el-option
                                        v-for="item in domain.showLogicCondition"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                  </el-select>
                                </div>

                                <div
                                    class="labelClass"
                                    style="float: left"
                                    v-show="domain.condSelect != 3 && domain.condSelect != 4"
                                >
                                  <el-select
                                      v-model="domain.selectOpt"
                                      placeholder="请选择选项"
                                      value-key="id"
                                  >
                                    <el-option
                                        v-for="item in domain.options"
                                        :key="item.id"
                                        :label="item.labelName"
                                        :value="item.id"
                                    >
                                    </el-option>
                                  </el-select>
                                </div>
                                <!--暂时隐藏添加、删除逻辑-->
                                <!--<div class="icon_num" style="float: left">
                                  <i
                                      class="icon iconfont iconjian"
                                  ></i>
                                  <i class="icon iconfont iconjia" ></i>
                                </div>-->
                                <div style="clear: both"></div>
                              </el-form-item>


                               <!-- <el-form-item  v-for="(domain, index) in item. domians"
                                    :key="index"
                                    style="border-bottom:none"
                                    >
                                    <div class="choiceQuestion" style="float:left">
                                        <el-select v-model="domain.title" placeholder="请选择题目" value-key="id">
                                            <el-option
                                                v-for="item in questionList"
                                                :key="item.id"
                                                :label="item.questionsName"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </div>
                                 <div class="labelClass" style="float:left;margin:0 15px">
                                        <el-select v-model="domain.condSelect" placeholder="请选择条件" value-key="id" @change="optionDemos">
                                            <el-option
                                                v-for="item in optionDemo"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="skipClass" style="floart:left">
                                        <el-select v-model="domain.selectOpt" placeholder="请选择题目" value-key="id" >
                                            <el-option
                                                v-for="item in questionList"
                                                :key="item.id"
                                                :label="item.questionsName"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                        <el-button icon="icon iconfont iconjian" circle @click.prevent="removeLogin(domain)" ></el-button>
                                        <el-button  icon="icon iconfont iconjia" circle @click="addLogin"></el-button>
                                    </div>
                                    
                                </el-form-item>

                            -->


                            </label>
                        </el-form>
                    </div>     
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
              questionList:[],
              dynamicValidateForm:{
                domains:[
                  {
                    choicQues:'', //问题id
                    selectOption:'', //选择的选项
                    jumpTitle:'',//要调转到的问题
                    optionList:'' //问题的所有选项列表

                  }
                ]
              },

                custom:[
                    {
                        label:'全部',
                        value:1
                    },
                    {
                        label:'任意',
                        value:2
                    }
                ],
           /*     dynam:{
                    demo:[
                        {
                            ques:'',
                            eligible:'全部'
                        }
                    ] ,
                    demo2:[
                        {
                            questionTitle:'',
                            condit:'',
                            disTitle:''
                        }
                    ] 
                },*/

              // 显示逻辑结构
              displayscriptitem: [{
                questionid:"",
                condition:"", //全部或任意
                domians: [
                  {
                    title: "",
                    condSelect: "",
                    selectOpt: "",
                    questionsTypeId:"",// 问卷题目类型
                    showLogicCondition: [
                      {
                        label: "选中",
                        value: "1",
                      },
                      {
                        label: "未选中",
                        value: "2",
                      },
                      {
                        label: "显示",
                        value: "3",
                      },
                      {
                        label: "不显示",
                        value: "4",
                      },
                    ],
                    options: [],
                  },
                ],
              }],


                jumpLogic:'1111',
                displayLogic:'',

                demo:[],

                titleId:'',
                optionDemo:[],
                jumpPosition:'',
                questionsOptionIdList:[],
                labelData:[
                    {
                        demo:[
                            {
                                ques:'',
                                eligible:'全部'
                            }
                        ] ,
                        demo2:[
                            {
                                questionTitle:'',
                                condit:'',
                                disTitle:''
                            }
                        ] 
                    }
                ],
                conditionType:1,
                displayType:'',
                questionsOptionId:[],
                relation:'',
              currentQuestionOptions: [], //当前问题选项
              currentSelectQuestionOptions: [], //当前问题选择的选项
            }
        },
        created(){
        },
        mounted(){
            this.wid = sessionStorage.getItem("wid");
            //加载所有的问题

            this.loadAllQuestion()

        },
        methods:{
          optionDemos(item){
                this.relation = item.id
                if(item.questionsTypeId == 6 || item.questionsTypeId == 8 || item.questionsTypeId == 9 || item.questionsTypeId == 10){
                  this.optionDemo = [
                    {
                      label:'选中',
                      value:'1'
                    },{
                      label:'未选中',
                      value:'2'
                    },{
                      label:'显示',
                      value:'3',
                    },{
                      label:'不显示',
                      value:'4'
                    }
                  ]
                }else{
                  this.optionDemo = [
                    {
                      label:'显示',
                      value:'3'
                    },{
                      label:'未显示',
                      value:'4'
                    }
                  ]
                }
              },
            quesName(){

            },
            elig(value){
                this.conditionType = value
            },
            choiceQuestion(){

            },
            // 获取选项id
            optionId(id){
                this.questionsOptionIdList.push(id)
            },
            // 设置添加单个跳转逻辑
            jumpTitle(id){
                let that = this
                let params = {
                    that: this,
                    url: `${this.$config.service.setupjumplogic}`,
                    method: "POST",
                    data:{
                        highScore:0,
                        lowScore:0,
                        jumpPosition:id,
                        questionsId:that.titleId,
                        questionsOptionIdList:that.questionsOptionIdList,
                    },
                    cb(res) {
                        if (res.code == 0) {
                            console.log('查询逻辑设置中添加单个跳转逻辑',res)  
                        }
                    }
                };
                this.$util.request(params);
            },
          getQuestionById(qtag)
          {
              for(var i=0;i<this.questionList.length;i++)
              {
                if(this.questionList[i].id == qtag)
                {
                  return this.questionList[i];
                }
              }
              return null;
          },
          // 查询所有添加的跳转逻辑
          queryJumpLogic() {
            let that = this;
            let params = {
              that: this,
              url: `${this.$config.service.queryJmupLog}`,
              method: "POST",
              data: {
                id:that.wid
              },
              cb(res) {
                if (res.code == 0) {
                  console.log("aaaaaa", res.resultBody.datas);
                  let arr = res.resultBody.datas;
                  let arrs = [];
                  for (let j = 0; j < arr.length; j++) {
                    let q= that.getQuestionById(arr[j].questionsId);
                    let domains = {
                      selectOption: arr[j].questionsOptionId,
                      quesTitle: arr[j].jumpPosition,
                      choicQues: arr[j].questionsId,
                      optionList:q.optionList
                    };
                    arrs.push(domains);
                  }
                  that.dynamicValidateForm.domains = arrs;
                } else {
                  that.dynamicValidateForm = {
                    domains: [
                      {
                        selectOption: "",
                        quesTitle: "",
                        choicQues:""
                      },
                    ],
                  };
                }
              },
            };
            this.$util.request(params);
          },

          // 查询所有添加的显示逻辑
          queryDisplayLogic() {
            let that = this;
            let params = {
              that: this,
              url: `${this.$config.service.queryDsiplatLog}`,
              method: "POST",
              data: {
                id:that.wid
              },
              cb(res) {
                if (res.code == 0) {
                  that.displayscriptitem = [];
                  console.log("aaaaaa", res.resultBody.datas);
                  let queryDsiplatlist = res.resultBody.datas;


              for (let j = 0; j < queryDsiplatlist.length; j++) {
                // 定义题目选项数组对象
                let questionObject = {}
                // 显示数组
                let optionlist = [];

                questionObject.questionid = queryDsiplatlist[j].questionsId;
                questionObject.condition = queryDsiplatlist[j].conditionType;
                if (queryDsiplatlist[j].displayLogics.length > 0) {
                  for (let i = 0; i < queryDsiplatlist[j].displayLogics.length; i++) {
                    // 显示对象
                    let option = {}
                    option.title = queryDsiplatlist[j].displayLogics[i].relationQuestionsId;
                    option.condSelect = queryDsiplatlist[j].displayLogics[i].displayType + "";
                    option.selectOpt = queryDsiplatlist[j].displayLogics[i].questionsOptionId;
                    option.options=[];
                    that.loadOptionsByQuestion(that.getQuestionById(option.title),option);
                    optionlist.push(option);
                  }
                }

                questionObject.domians = optionlist;
                that.displayscriptitem.push(questionObject);
              }
              console.log("displayscriptitem",displayscriptitem);
                }
              },
            };
            this.$util.request(params);
          },

          //加载指的问题的选项，逻辑脚本内使用
          loadOptionsByQuestion(q, domain) {
            let that = this;
            var tempOptions = [];

            if (
                q.questionsTypeId == 6 ||
                q.questionsTypeId == 8 ||
                q.questionsTypeId == 9 ||
                q.questionsTypeId == 10 ||
                q.questionsTypeId == 12
            ) {
              domain.showLogicCondition = [
                {
                  label: "选中",
                  value: "1",
                },
                {
                  label: "未选中",
                  value: "2",
                },
                {
                  label: "显示",
                  value: "3",
                },
                {
                  label: "不显示",
                  value: "4",
                },
              ];
              for (var i = 0; i < q.optionList.length; i++) {
                tempOptions.push(q.optionList[i]);
              }
              tempOptions.push({ id: "0", labelName: "任意选项" });
              domain.options = tempOptions;
            } else {
              domain.showLogicCondition = [
                {
                  label: "显示",
                  value: "3",
                },
                {
                  label: "未显示",
                  value: "4",
                },
              ];
            }
          },
            // 获取当前选中的题目的选项
            choiceTitle(item){
                this.titleId = item.id
                let that = this
                let params = {
                    that: this,
                    url: `${this.$config.service.queryDefault}`,
                    method: "POST",
                    data:{
                        id:item.id
                    },
                    cb(res) {
                        if (res.code == 0) {
                            that.optionDemo = res.resultBody.datas
                            console.log('查询逻辑设置中跳转逻辑选中题目的指定选项',res)  
                        }
                    }
                };
                this.$util.request(params);
            },
            loadAllQuestion(){
                let that = this
                let params = {
                    that: this,
                    url: `${this.$config.service.selectAllPage}`,
                    method: "POST",
                    data:{
                        id:that.wid
                    },
                    cb(res) {
                        if (res.code == 0) {
                            that.questionList = res.resultBody.datas
                          //加载所有的跳转逻辑
                          that.queryJumpLogic();
                          //加载所有的显示逻辑
                          that.queryDisplayLogic();
                            console.log('查询逻辑设置中跳转逻辑',res)  
                        }
                    }
                };
                this.$util.request(params);
            },
            addLogin(){
                this.labelData.demo2.push([
                    {
                       questionTitle:'',
                        condit:'',
                        disTitle:'',
                        key: Date.now()
                    }
                ])
              
            },
            removeDomain(item){
                var index = this.dynamicValidateForm.domains.indexOf(item)
                if (index !== -1) {
                    this.dynamicValidateForm.domains.splice(index, 1)
                }
            },
            removeLogin(item){
                var index2 = this.labelData.demo2.indexOf(item)
                if (index2 !== -1) {
                    this.labelData.demo2.splice(index2, 1)
                }
            },
            addjumpLogic(){
                this.dynamicValidateForm.domains.push({
                    choicQues:'',
                    labelName:'',
                    jumpTitle:'',
                    key: Date.now()
                });
                 console.log(this.dynamicValidateForm.domains)
            },
            adddisplayLogic1(){
                this.labelData.push(
                   { 
                       key: Date.now(),
                        demo:[
                            {
                                ques:'',
                                eligible:'全部'
                            }
                        ] ,
                        demo2:[
                            {
                                questionTitle:'',
                                condit:'',
                                disTitle:''
                            }
                        ] 
                    }
                )
                console.log(this.labelData)
            }
        }
    }
</script>

<style scoped>
    /deep/.skipClass .el-button{
        border:none !important;
    }
    .logic{
        width:1160px;
        height:auto;
        margin:0 auto;
        margin-top:62px;
    }
    .jump_logic p{
        font-size:18px;
        color:#333;
        margin-left:30px;
        padding-top:50px;
    }
    .display_logic p{
        font-size:18px;
        color:#333;
        margin-left:30px;
        margin-top:50px;
    }
    .add_box{
        width:100%;
        height:100px;
        background: #fff;
        margin-top:14px;
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .add_box i {
        font-size:24px;
        color:#999;
    }
    .add_box span{
        font-size:14px;
        color:#666;
        margin-top:15px;
    }
    .public_box{
        width:100%;
        height:52px;
        display:flex;
        justify-content: space-between;
        align-items: center;
        background:#ffffff;
        border-bottom:1px solid #e3e3e3;
    }
    .public_box span{
        font-size:14px;
        margin-left:30px
    }
    /deep/.public_box .el-button{
        margin-right:30px;
    }
    /deep/.choiceQuestion .el-input__inner{
        width:180px !important;
    }
    /deep/.labelClass .el-input__inner{
        width:140px !important;
    }
    /deep/.skipClass .el-input__inner{
        width:140px !important;
    }
    /deep/.el-form-item{
        height: 64px !important;
        line-height:64px !important;
        border-bottom:1px solid #cccccc;
        margin-bottom:0px;
        overflow: hidden;
    }
    /deep/.el-form-item__content{
        height: 64px !important;
        line-height:64px !important;
    }
    /deep/.el-form-item__label{
        margin-top:12px;
    }
    .label{
        /* overflow: hidden; */
    }
</style>